import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const BTP = () => {
  const sectorData = {
    title: "BTP",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Dans le BTP, la prospection est une affaire de timing, de réassurance et de capacité à s'intégrer dans des chaînes d'intervenants. Pour toucher les architectes, AMO, MOA ou acheteurs, les entreprises doivent produire des références chantier, utiliser les bons moments d'achat et démontrer leur solidité technique.",
    name: "BTP",
    titleContext: "du secteur du BTP",
    responseContext: "du secteur du BTP",
    expertContext: "du secteur du BTP"
  };

  return <SectorPage sector={sectorData} />;
};

export default BTP; 